import { render, staticRenderFns } from "./AppReceiptA4_02.vue?vue&type=template&id=4cc04ef3&scoped=true&"
import script from "./AppReceiptA4_02.vue?vue&type=script&lang=js&"
export * from "./AppReceiptA4_02.vue?vue&type=script&lang=js&"
import style0 from "./AppReceiptA4_02.vue?vue&type=style&index=0&id=4cc04ef3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cc04ef3",
  null
  
)

export default component.exports